import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

const usePrincipalGet = (principalId, skip = false) => {
  const requestUrl = `${API_BASE_URL}/api/v2/principal/${principalId}/`;
  return useRestQuery(requestUrl, { skip: !principalId || skip });
};

export default usePrincipalGet;
